import axios from "axios";
import { API_BASE_LOCAL_URL } from "../config";

// Create Axios Instance
const api = axios.create({
  baseURL: API_BASE_LOCAL_URL,
});

// Attach JWT Token Automatically
api.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Auto Logout On Token Expiry
api.interceptors.response.use(
  (response) => response,

  (error) => {

    if (error.response && error.response.status === 401) {

      localStorage.clear();
      window.location.href = "/login";
    }

     if (error.response && error.response.status === 403) {

      console.warn("Access denied:", error.response.data?.message);

      // Do NOT crash app
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
